import styled, { css } from 'styled-components';
import { Star } from 'lucide-react';

const fontSizes = {
  sm: css`
    font-size: clamp(11px, 0.28vw + 10px, 14px);
  `,
  md: css`
    font-size: clamp(13px, 0.38vw + 11px, 18px);
  `,
  lg: css`
    font-size: clamp(15px, 0.52vw + 12px, 22px);
  `,
};

const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  ${({ $size }) => fontSizes[$size] || fontSizes.md}

  svg {
    width: 1em;
    height: 1em;
  }
`;

const Btn = styled.button`
  position: relative;
  display: inline-block;
  padding: 0;
  border: none;
  background: none;
  line-height: 0;
  font-size: inherit;
  cursor: ${({ $interactive }) => ($interactive ? 'pointer' : 'default')};

  &:disabled {
    cursor: default;
  }

  ${({ $interactive }) =>
    $interactive &&
    `
    transition: transform 0.2s ease;
    &:hover:not(:disabled) {
      transform: scale(1.1);
    }
  `}
`;

export default function StarRating({
  rating = 0,
  size = 'md',
  interactive,
  onChange,
  className,
}) {
  const tier = ['sm', 'md', 'lg'].includes(size) ? size : 'md';
  const fg = 'hsla(25, 8%, 12%, 1)';
  const track = 'hsla(38, 12%, 80%, 1)';

  return (
    <Wrap
      className={className}
      $size={tier}
      aria-label={`Rating: ${Number(rating).toFixed(1)} out of 5`}
    >
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = rating >= i;
        const half = !filled && rating >= i - 0.5;
        return (
          <Btn
            key={i}
            type="button"
            disabled={!interactive}
            $interactive={interactive}
            onClick={() => interactive && onChange?.(i)}
            aria-label={`${i} star${i > 1 ? 's' : ''}`}
          >
            <Star strokeWidth={1.75} absoluteStrokeWidth color={track} fill="none" aria-hidden />
            {(filled || half) && (
              <Star
                strokeWidth={0}
                color={fg}
                fill={fg}
                aria-hidden
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  clipPath: half ? 'inset(0 50% 0 0)' : undefined,
                  pointerEvents: 'none',
                }}
              />
            )}
          </Btn>
        );
      })}
    </Wrap>
  );
}
